// @ts-nocheck

import React from 'react';
import styled from 'styled-components';

import CurrencyExposant from '../CurrencyExposant';

const Wrap = styled.p`
  width: 100%;
  text-align: right;
  margin: 0;
`;

const Amount = styled(CurrencyExposant)`
  background: ${({ theme }) => theme.grids.colors.darkgrey5};
  color: #fff;
  padding: 0.6em;
  border-radius: 0.2em 0 0 0.2em;
`;

const SystemGridAmount = ({ amount }) => (
  <Wrap>
    <Amount amount={amount} />
  </Wrap>
);

export default SystemGridAmount;
